import styled from 'styled-components';
import {
  Divider as SemanticDivider,
  Radio as SemanticRadio,
} from 'semantic-ui-react';

import { Button as ButtonLayoutComponent, Header, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  margin-top: 30px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  @media (min-width: 320px) and (max-width: 767px) {
    flex-direction: column;
  }
`;

export const Section = styled.div`
  margin-bottom: 20px;
`;

export const Title = styled(Header)``;

export const Text = styled(TextLayoutComponent)`
  max-width: 65ch;
`;

export const Link = styled.a``;

export const OptionsContainer = styled.div`
  margin: 12px 0;
`;

export const Option = styled.div`
  display: flex;
  gap: 5px;
`;

export const Radio = styled(SemanticRadio)``;

export const SaveButton = styled(ButtonLayoutComponent)`
  align-self: flex-end;
  width: 80px;
  @media (min-width: 320px) and (max-width: 767px) {
    margin-top: 20px;
  }
`;

export const Divider = styled(SemanticDivider)`
  &.ui.divider {
    border-top: 1px solid #EDEDED;
    margin-top: 5px;
  }
`;
